import axios from "axios";
import { clearLogoutData } from "../../logout/action";
import { Documents_Master_Service_URL } from "./../../Url";

export const GetDocumentsActions = {
  GET_DOCUMENTS_REQUEST: "GET_DOCUMENTS_REQUEST",
  GET_DOCUMENTS_LOADING: "GET_DOCUMENTS_LOADING",
  GET_DOCUMENTS_SUCCESS: "GET_DOCUMENTS_SUCCESS",
  GET_DOCUMENTS_ERROR: "GET_DOCUMENTS_ERROR",
};

export const getDocuments = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId } = props;
  dispatch(getDocumentsLoading());
  return axios({
    method: "post",
    url: `${Documents_Master_Service_URL}/getDocument`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(getDocumentsSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);

        throw error;
      }
    })
    .catch((error) => {
      if (error.response) {
        dispatch(getDocumentsError(error));
      }

      throw error;
    });
};

export function getDocumentsError(error) {
  return {
    type: GetDocumentsActions.GET_DOCUMENTS_ERROR,
    payload: error,
  };
}

export function getDocumentsSuccess(props) {
  return {
    type: GetDocumentsActions.GET_DOCUMENTS_SUCCESS,
    payload: props,
  };
}

export function getDocumentsLoading() {
  return {
    type: GetDocumentsActions.GET_DOCUMENTS_LOADING,
  };
}


export const GetRcuDocumentsActions = {
  GET_RCU_DOCUMENTS_REQUEST: "GET_RCU_DOCUMENTS_REQUEST",
  GET_RCU_DOCUMENTS_LOADING: "GET_RCU_DOCUMENTS_LOADING",
  GET_RCU_DOCUMENTS_SUCCESS: "GET_RCU_DOCUMENTS_SUCCESS",
  GET_RCU_DOCUMENTS_ERROR: "GET_RCU_DOCUMENTS_ERROR",
};




export const getRcuDocuments = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId } = props;
  dispatch(getRcuDocumentsLoading());
  return axios({
    method: "post",
    url: `${Documents_Master_Service_URL}/get/rcuFiDocument/ByPartnerFirmId`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(getRcuDocumentsSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);

        throw error;
      }
    })
    .catch((error) => {
      if (error?.response) {
        dispatch(getRcuDocumentsError(error));
      }
      throw error;
    });
};



export function getRcuDocumentsError(error) {
  return {
    type: GetRcuDocumentsActions.GET_RCU_DOCUMENTS_ERROR,
    payload: error,
  };
}

export function getRcuDocumentsSuccess(props) {
  return {
    type: GetRcuDocumentsActions.GET_RCU_DOCUMENTS_SUCCESS,
    payload: props,
  };
}

export function getRcuDocumentsLoading() {
  return {
    type: GetRcuDocumentsActions.GET_RCU_DOCUMENTS_LOADING,
  };
}





export const getRcuDocumentType = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId, section } = props;
  dispatch(getRcuDocumentsLoading());
  return axios({
    method: "post",
    url: `${Documents_Master_Service_URL}/get/DocumentTypeMastersBySection?section=${section}`,
    headers: {
      authorization: "Bearer " + accessToken,
    },

  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(getRcuDocumentsSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);

        throw error;
      }
    })
    .catch((error) => {
      if (error?.response) {
        dispatch(getRcuDocumentsError(error));
      }
      throw error;
    });
};